import { QueryClient } from '@tanstack/react-query';
const queryConfig = {
  queries: {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    retry: false // staleTime: 10000,

  }
};
export const queryClient = new QueryClient({
  defaultOptions: queryConfig
});